import LoggedIn from "../layouts/loggedIn.layout";
import DefaultLayout from "../layouts/default.layout";
import CardTemplate from "../components/cards/template/card.template.component";
import {useParams, useSearchParams} from "react-router-dom";
import {UserContext} from "../contexts/user.context";
import {useContext} from "react";
import CustomerCreateForm from "../components/forms/customerCreate.form";

const CustomerEdit = () => {
  const { customerId } = useParams();
  const [searchParams] = useSearchParams();

  const {user} = useContext(UserContext);
  const heading =  "Create Customer";

  return (
      <LoggedIn>
        <DefaultLayout title={heading}>
          <CardTemplate>
            <CustomerCreateForm />
          </CardTemplate>
        </DefaultLayout>
      </LoggedIn>
  );
};

export default CustomerEdit;
